import mintNft from "../mintNft";
import configs from "../utils/configs";
import { guessContentType } from "../utils/media-url-utils";

AFRAME.registerComponent("mint-nft-button", {
  init() {
    if (!configs.NFT_MARKETPLACE_URL) {
      this.el.parentNode.removeChild(this.el);
      return;
    }

    this.updateSrc = () => {
      if (!this.targetEl.parentNode) return; // If removed
      const src = (this.src = this.targetEl.components["media-loader"].data.src);
      const contentType = guessContentType(src);
      const contentSubtype = this.targetEl.components["media-loader"].data.contentSubtype ?? "";
      const visible = src && contentType && contentType !== "video/vnd.hubs-webrtc" && contentSubtype !== "message";

      this.el.object3D.visible = !!visible && NAF.utils.isMine(this.targetEl);
    };

    NAF.utils.getNetworkedEntity(this.el).then(networkedEl => {
      this.targetEl = networkedEl;
      this.targetEl.addEventListener("media_resolved", this.updateSrc, { once: true });
      this.updateSrc();
    });

    this.onClick = () => {
      mintNft(this.src);
    };
  },

  play() {
    this.el.object3D.addEventListener("interact", this.onClick);
  },

  pause() {
    this.el.object3D.removeEventListener("interact", this.onClick);
  }
});
